// Components
import {
  FooterContainer,
  InstagramLogo,
  TwitterLogo,
  YoutubeLogo,
  LinkedinLogo,
  FooterBottom,
  Copyright,
  FooterIcons,
  SocialLink,
} from 'remote-com-shared/components/Footer/styles';
import styled from 'styled-components';

const currentYear = new Date().getFullYear();

const FooterBottomWrapper = styled(FooterBottom)`
  border: none;
`;

export const FooterContainerWrapper = styled(FooterContainer)`
  padding-top: 0;
`;

const WebinarFooter = () => (
  <FooterContainerWrapper>
    <FooterBottomWrapper>
      <Copyright>Copyright © {currentYear} Remote Technology, Inc. All rights reserved.</Copyright>
      <FooterIcons>
        <SocialLink
          href="https://www.youtube.com/channel/UCPJsrP8zyttajAybEMQBNgA"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Remote on YouTube"
        >
          <YoutubeLogo />
        </SocialLink>
        <SocialLink
          href="https://www.linkedin.com/company/remote.com"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Remote on LinkedIn"
        >
          <LinkedinLogo />
        </SocialLink>
        <SocialLink
          href="https://twitter.com/remote"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Remote on Twitter"
        >
          <TwitterLogo />
        </SocialLink>
        <SocialLink
          href="https://www.instagram.com/remote/"
          target="_blank"
          rel="noreferrer"
          aria-label="Visit Remote on Instagram"
        >
          <InstagramLogo />
        </SocialLink>
      </FooterIcons>
    </FooterBottomWrapper>
  </FooterContainerWrapper>
);

export default WebinarFooter;
